// STORY-033: Types de notifications (alignés sur le schéma DB)

// Types réels en base de données
export type NotificationType =
  | 'ticket'
  | 'devis'
  | 'payment'
  | 'project'
  | 'reminder'
  | 'system'

// Notification telle qu'en base
export interface Notification {
  id: string
  user_id: string
  type: NotificationType
  title: string | null
  message: string
  link: string | null
  read: boolean
  created_at: string
}

// Filtres pour les notifications
export interface NotificationFilters {
  type?: NotificationType
  read?: boolean
  dateFrom?: string
  dateTo?: string
  limit?: number
}

// Stats des notifications
export interface NotificationStats {
  total: number
  unread: number
}

// Type pour créer une notification
export interface CreateNotificationData {
  type: NotificationType
  title?: string
  message: string
  link?: string
  user_id?: string
}

// Labels pour l'UI
export const notificationTypeLabels: Record<NotificationType, string> = {
  ticket: 'Ticket',
  devis: 'Devis',
  payment: 'Paiement',
  project: 'Projet',
  reminder: 'Relance',
  system: 'Système',
}

// Couleurs par type de notification
export const notificationTypeColors: Record<NotificationType, { bg: string; icon: string }> = {
  ticket: { bg: 'bg-gold-100', icon: 'text-gold-600' },
  devis: { bg: 'bg-purple-100', icon: 'text-purple-600' },
  payment: { bg: 'bg-mint-100', icon: 'text-mint-600' },
  project: { bg: 'bg-blue-100', icon: 'text-blue-600' },
  reminder: { bg: 'bg-red-100', icon: 'text-red-600' },
  system: { bg: 'bg-beige-100', icon: 'text-beige-600' },
}
